"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/modal/style/css");
var modal_1 = __importDefault(require("antd/lib/modal"));
require("antd/lib/card/style/css");
var card_1 = __importDefault(require("antd/lib/card"));
require("antd/lib/descriptions/style/css");
var descriptions_1 = __importDefault(require("antd/lib/descriptions"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var json_viewer_1 = require("@textea/json-viewer");
var utils_1 = require("../../utils");
var MapPreview_1 = __importDefault(require("./MapPreview"));
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var styles = {
    jsonCard: {
        marginTop: 16
    }
};
var layerDetailTitle = (0, utils_1.detailTitle)("Layer", "name");
var LayerDetailView = /*#__PURE__*/ react_1.default.memo(function () {
    var _layer$name, _layer$rank;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _useParams = (0, react_router_dom_1.useParams)(), layerID = _useParams.id;
    var _useState = (0, react_1.useState)(false), _useState2 = _slicedToArray(_useState, 2), previewShown = _useState2[0], setPreviewShown = _useState2[1];
    var layersInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.layers.initialFetchDone;
    });
    var layersFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.layers.isFetching;
    });
    var layer = (0, react_redux_1.useSelector)(function (state) {
        return (0, utils_1.findItemByID)(state.layers.items, layerID);
    });
    var layerArr = (0, react_1.useMemo)(function () {
        return [layer];
    }, [layer]);
    var geoJSON = (0, react_1.useMemo)(function () {
        var _layer$geojson;
        return (_layer$geojson = layer === null || layer === void 0 ? void 0 : layer.geojson) !== null && _layer$geojson !== void 0 ? _layer$geojson : {};
    }, [layer]);
    var onBack = (0, react_1.useCallback)(function () {
        return navigate(-1);
    }, [navigate]);
    var showPreview = (0, react_1.useCallback)(function () {
        return setPreviewShown(true);
    }, []);
    var hidePreview = (0, react_1.useCallback)(function () {
        return setPreviewShown(false);
    }, []);
    var editLayer = (0, react_1.useCallback)(function () {
        return navigate("/layers/edit/".concat(layerID));
    }, [navigate, layerID]);
    var title = (0, react_1.useMemo)(function () {
        return layerDetailTitle(layer, layersInitialFetch, layersFetching);
    }, [layersFetching, layer]);
    var extra = (0, react_1.useMemo)(function () {
        return [(0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.EyeOutlined, {}),
                onClick: showPreview,
                children: "Preview Layer"
            }, "preview"), (0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
                onClick: editLayer,
                children: "Edit"
            }, "edit")];
    }, [showPreview, editLayer]);
    // noinspection JSValidateTypes
    return (0, jsx_runtime_1.jsxs)(page_header_1.default, {
        ghost: false,
        onBack: onBack,
        title: title,
        extra: extra,
        children: [(0, jsx_runtime_1.jsxs)(descriptions_1.default, {
                bordered: true,
                size: "small",
                children: [(0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Name",
                        children: (_layer$name = layer === null || layer === void 0 ? void 0 : layer.name) !== null && _layer$name !== void 0 ? _layer$name : ""
                    }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Enabled",
                        children: layer !== null && layer !== void 0 && layer.enabled ? "Yes" : "No"
                    }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Rank",
                        children: (_layer$rank = layer === null || layer === void 0 ? void 0 : layer.rank) !== null && _layer$rank !== void 0 ? _layer$rank : "—"
                    })]
            }), (0, jsx_runtime_1.jsx)(card_1.default, {
                size: "small",
                title: "GeoJSON",
                style: styles.jsonCard,
                children: (0, jsx_runtime_1.jsx)(json_viewer_1.JsonViewer, {
                    value: geoJSON,
                    groupArraysAfterLength: 50
                })
            }), (0, jsx_runtime_1.jsx)(modal_1.default, {
                title: "Layer Preview",
                open: previewShown,
                footer: null,
                onCancel: hidePreview,
                width: 800,
                children: (0, jsx_runtime_1.jsx)(MapPreview_1.default, {
                    layers: layerArr
                })
            })]
    });
});
exports.default = LayerDetailView;
